
import Vue from "vue";
import { CodaService, ICodaImportResult } from "../../services/coda-service";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import AppSelectBankType from "./SelectBankType.vue";
import {HttpError} from "@/utils/services/http-error";

export default Vue.extend({
	data() {
		return {
			bankId: 1,
			file: null as null | File,
			files: [] as File[] | File[],
			uploading: false
		};
	},
	props: {
		editBankId: Number
	},
	watch: {
		"editBankId"(){
			this.bankId = this.editBankId;
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		append($event: File){
			this.files?.push($event);
		},
		async upload() {
			try{
				if (!this.files) {
					return;
				}
				this.uploading = true;
				let bankId = this.bankId;
				//try {

				let r = {} as ICodaImportResult;

				this.files.sort((a,b) => a.lastModified - b.lastModified);
				r.Banks = [];

				for (let file of this.files){
					let result = await CodaService.postCoda(file, bankId);
					if(!r.BeginBalance){
						r.BeginBalance = result.BeginBalance;
					}
					r.Banks = [...r.Banks,...result.Banks];
					r.EndBalance = result.EndBalance;
					r.AccountNumber = result.AccountNumber;
				}
				this.$emit("result", r, bankId);
				/*} catch(err) {
					console.log(err);
					}*/
			}catch(err){
				let hErr = err as HttpError;
				if (hErr.status){
					this.$wf.notify(this.$ct("coda-file-is-not-valid"), "danger", 3000, "exclamation-triangle");
				}
			}finally{
				this.uploading = false;
			}
		}
	},
	components: {
		AppFileUpload,
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
